import { NotificationsService } from 'angular2-notifications';
import { animate, group, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, OnDestroy, OnInit, ViewChild, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { OrdersHistoryPresenter } from '@business/orders-history/orders-history.presenter';
import { NormalModalComponent } from '@component/normal-modal/normal-modal.component';
import { HistoryFilterOrder } from '@model/webFeeder/history-filter-order';
import { HistoryOrder } from '@model/webFeeder/history-order.model';
import { CustomSnackbarService } from '@services/custom-snackbar-service.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { Constants } from '@utils/constants';
import { Subject, Subscription , of } from 'rxjs';
import { AuthServer } from '@services/auth-server.service';
import { environment } from 'src/environments/environment';
import { AppUtils } from '@utils/app.utils';
import { StatusOmsService } from '@services/webFeeder/sckt-status-oms.service';
import { StatusConnection } from '@model/status-connection';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';
import { CancelOrder } from '@model/webFeeder/message-cancel-order';
import { Quote } from '@model/webFeeder/quote.model';
import { take } from 'rxjs';

@Component({
  selector: 'app-orders-history',
  templateUrl: './orders-history.component.html',
  animations: [
    trigger('animateDetails', [
      transition('void => *', [
        group([
          animate(
            '.5s ease-in-out',
            keyframes([
              style({
                opacity: 0,
                transform: 'translateY(-200%)',
                height: 0,
                offset: 0
              }),
              style({
                opacity: 0,
                transform: 'translateY(-50%)',
                height: 10,
                offset: 0.4
              }),
              style({
                opacity: 1,
                transform: 'translateY(0)',
                height: '*',
                offset: 1
              })
            ])
          )
        ])
      ])
    ]),
    trigger('animateDetailsClose', [
      transition('* => void', [
        style({ transform: 'translateY(0)' }),
        group([
          animate(
            '.5s ease',
            keyframes([
              style({
                opacity: 1,
                transform: 'translateY(0)',
                height: '*',
                offset: 0
              }),
              style({
                opacity: 0,
                transform: 'translateY(-50%)',
                height: 10,
                offset: 0.4
              }),
              style({
                opacity: 0,
                transform: 'translateY(-200%)',
                height: 0,
                offset: 1
              })
            ])
          )
        ])
      ])
    ])
  ]
})
export class OrdersHistoryComponent implements OnInit, OnDestroy {

  typeFilter = [
    {
      cod: 1,
      descFilter: 'Todos',
      webfeeder: '',
      dailyFilter: 'Todos'
    },
    {
      cod: 2,
      descFilter: 'Limitada',
      webfeeder: 'Limited',
      dailyFilter: 'Limitada'
    },
    {
      cod: 3,
      descFilter: 'Mercado com proteção',
      webfeeder: 'Market',
      dailyFilter: 'Mercado com proteção'
    },
    {
      cod: 4,
      descFilter: 'Mercado limite',
      webfeeder: 'Mercado limite',
      dailyFilter: 'Mercado limite'
    },
    { cod: 5, descFilter: 'Stop', webfeeder: 'Stop', dailyFilter: 'Stop' }
  ];
  buySellFilter = [
    { cod: 1, descFilter: 'Todas', webfeeder: '' },
    { cod: 2, descFilter: 'Compra', webfeeder: 'buy' },
    { cod: 3, descFilter: 'Venda', webfeeder: 'sell' }
  ];
  MarketFilter = [
    { cod: 0, descFilter: 'Todos', webfeeder: 'Todos' },
    { cod: 1, descFilter: 'Bovespa', webfeeder: 'Bovespa' },
    { cod: 2, descFilter: 'BM&F', webfeeder: 'BM&F' }
  ];
  statusFilter = [
    { cod: 0, descFilter: 'Todas', webfeeder: null, dailyFilter: ['Todas'] },
    {
      cod: 1,
      descFilter: 'Abertas',
      webfeeder: 'New',
      dailyFilter: [
        'Aberta',
        'Nova',
        'Parcialmente Executada',
        'Editada',
        'Cancelamento Pendente',
        'Pendente',
        'Edição Pendente',
        'Suspensa'
      ]
    },
    {
      cod: 2,
      descFilter: 'Executadas',
      webfeeder: 'Filled',
      dailyFilter: ['Executada']
    },
    {
      cod: 3,
      descFilter: 'Canceladas',
      webfeeder: 'Canceled',
      dailyFilter: ['Cancelada']
    },
    {
      cod: 4,
      descFilter: 'Rejeitadas',
      webfeeder: 'Rejected',
      dailyFilter: ['Rejeitada']
    },
    {
      cod: 5,
      descFilter: 'Expirada',
      webfeeder: 'Expired',
      dailyFilter: ['Expirada']
    }
  ];
  changingValue: Subject<boolean> = new Subject();
  symbol = '';
  currentFilter = '';
  filterDirection = 0;
  loading = true;
  model: HistoryFilterOrder;
  private historyOrderPresenter: OrdersHistoryPresenter;
  account: string;
  idDetails = -1;
  idEdit = -1;
  stateDetail = false;
  stateDetailClose = true;
  list;
  orderList: HistoryOrder[] = [];
  dailyOrderAuxList: HistoryOrder[] = [];
  selectedTab = 0;
  subscriptions: Array<Subscription> = [];
  numberOfLines = 20;
  filteredList = []; // mudar retirar do paginator
  filteredHistory = []; // mudar retirar do paginator
  dataIni = new Date();
  dataFim = new Date();
  dailyStatusFilter;
  dailyTypeFilter;
  dailyDirectionFilter;
  dailyMarketFilter;
  dailySymbolFilter;
  dialog: MatDialog;
  openStatus = Constants.ORDER_HISTORY_STATUS[1];
  statusOmsOnline: boolean;
  msgStatusOmsOffile = Constants.MSG_STATUS_OFFLINE_OMS;
  eletronicSignature = this._configService.getEletronicSignatureType();
  filterDateRange: number;
  dailyOrderSubscription: Subscription;
  msgNoOrdersFound = Constants.MSG_NO_ORDERS_FOUND;
  wasHistoryFetched = false;

  @ViewChild('historyOrdens', { read: ViewContainerRef }) parent: ViewContainerRef;
  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    dialog: MatDialog,
    private _snackBar: CustomSnackbarService,
    private _configService: ConfigService,
    private _dailyOrderService: DailyOrderService,
    public dialogRef: MatDialogRef<OrdersHistoryComponent>,
    private _autoLogoutService: AutoLogoutService,
    private _authServer: AuthServer,
    private _statusOmsService: StatusOmsService,
    private cdRef: ChangeDetectorRef,
    private _notificationService: NotificationsService
  ) {
    this.account = this._configService.getBrokerAccountSelected();
    this.filterDateRange = this._configService.getOrderHistoryFilterRange();
    this.dialog = dialog;
    this.model = new HistoryFilterOrder();
    this.historyOrderPresenter = new OrdersHistoryPresenter();
    this.model.typeDateFilter = 'today';
    this.resetFilter();

    this.subscriptions.push(this._statusOmsService.messagesStatusOms
      .subscribe(statusOms => {
        if (statusOms === StatusConnection.ERROR) {
          this.loading = false;
          this.statusOmsOnline = false;
        } else {
          this.statusOmsOnline = true;
        }
      }));
    this.subscriptions.push(this._dailyOrderService.subscribeDailyOrder(this.account, Constants.WINDOW_NAME_HISTORY_ORDER)
      .subscribe(data => {
        this.updateDailyOrders(data);
      }));
    this.subscriptions.push(this._dailyOrderService.messagesDailyOrder
      .subscribe(res => {
        this.updateDailyOrders(res);
      }));
  }

  ngOnInit() {
    // TODO Remover quando refatorar o FT para parametrização dos tipos de mercado.
    if (environment.WHITELABEL === 2) {
      this.MarketFilter.shift();
      this.MarketFilter.pop();
    }
    this.dataIni.setDate(this.dataIni.getDate() - 1);
  }

  updateDailyOrders(response) {
    if (response && response.length > 0) {
      const presenterRes = [...this.historyOrderPresenter.transformDailyOrder(response)];
      for (let i = 0; i < presenterRes.length; i++) {
        this.dailyOrderAuxList = this.dailyOrderAuxList.filter(
          element => element.orderID != presenterRes[i].orderID
        );
        this.dailyOrderAuxList.push(presenterRes[i]);
      }
      this.dailyOrderAuxList = [...this.sortWebfeederDate(this.dailyOrderAuxList)];
      if (this.selectedTab === 0) {
        this.onSearchDaily();
      }
    }
    this.loading = false;
  }

  ngOnDestroy() {
    this._dailyOrderService.unsubscribeDailyOrder(this.account, Constants.WINDOW_NAME_HISTORY_ORDER);
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.changingValue.unsubscribe();
  }

  onSearchDaily() {
    this.dailyStatusFilter = this.statusFilter.find(p => p.descFilter === this.model.status).dailyFilter;
    this.dailyTypeFilter = this.typeFilter.find(p => p.descFilter === this.model.type).dailyFilter.toString();
    this.dailyDirectionFilter = this.buySellFilter.find(p => p.descFilter === this.model.direction).descFilter;
    this.dailyMarketFilter = this.MarketFilter.find(p => p.descFilter === this.model.market).descFilter.toString();
    this.dailySymbolFilter = this.model.symbol;
    const auxList = [...this.dailyOrderAuxList];
    this.orderList = [...this.filterDaily(auxList)];
  }

  onSearchHistory() {
    const dataInicio = this.dataIni.toUTCString();
    const dataFim = this.dataFim.toUTCString();
    if (dataInicio !== dataFim && !AppUtils.validateDateRange(dataInicio, dataFim, this.filterDateRange)) {
      const msg = Constants.DATE_MSG005.replace('{{range}}', this.filterDateRange.toString());
      this._snackBar.createSnack(this.parent, msg, Constants.ALERT_TYPE.warn);
      return;
    }
    this.loading = true;
    this.wasHistoryFetched = true;
    const market = this.MarketFilter.find(p => p.descFilter == this.model.market).cod.toString();
    const direction = this.buySellFilter.find(p => p.descFilter == this.model.direction).webfeeder;
    const status = this.statusFilter.find(p => p.descFilter === this.model.status).webfeeder;
    const type = this.typeFilter.find(p => p.descFilter == this.model.type).webfeeder.toString();
    this._authServer.iNegotiation.getHistoryOrder(this.account, market, dataInicio, dataFim,
      this.model.symbol, status, direction, null, type, null)
      .subscribe((historyOrder: any) => {
        if (!historyOrder.listBeans) {
          this.orderList = [];
          this.loading = false;
          if (historyOrder && historyOrder.message) {
            this._notificationService.error('', historyOrder.message);
          }
        } else {
          this.orderList = this.historyOrderPresenter.transformHistoryOrder(historyOrder);
          this.orderList = this.sortWebfeederDate(this.orderList);
          this.orderList = this.postFilterType(this.orderList);
          this.loading = false;
        }
      });
  }

  sortWebfeederDate(value) {
    if (value) {
      return value.sort(function (obj1, obj2) {
        let datearray = obj1.transactTime.substring(0, 10).split('/');
        let newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
        const dateobj1 = new Date(newdate + obj1.transactTime.substring(10, 19));
        datearray = obj2.transactTime.substring(0, 10).split('/');
        newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
        const dateobj2 = new Date(newdate + obj2.transactTime.substring(10, 19));
        return dateobj2.getTime() - dateobj1.getTime();
      });
    }
  }

  postFilterType(list) {
    if (list) {
      return list.filter(x => this.model.type == 'Todos' || x.type.includes(this.model.type));
    } else {
      return [];
    }
  }

  filterDaily(list) {
    const symbol = this.dailySymbolFilter;
    const market = this.dailyMarketFilter;
    const direction = this.dailyDirectionFilter;
    const status = this.dailyStatusFilter;
    const type = this.dailyTypeFilter;
    const filteredArray = list.filter(
      value => (symbol == '' || value.quote.toLowerCase() == symbol.toLowerCase()) &&
        (market == 'Todos' || value.mercado.toLowerCase() == market.toLowerCase()) &&
        (direction == 'Todas' || value.buyOrSell.toLowerCase() == direction.toLocaleLowerCase()) &&
        (status == 'Todas' || status.includes(value.state) || status == value.state) &&
        (type == 'Todos' || value.type.includes(type))
    );
    return filteredArray;
  }

  private resetFilter() {
    this.filterDirection = 0;
    this.dataFim = new Date();
    this.dataIni = new Date(this.dataIni.setDate(this.dataFim.getDate() - 1));
    this.symbol = '';
    this.idDetails = -1;
    this.idEdit = -1;
    this.dailySymbolFilter = this.model.symbol = '';
    this.dailyTypeFilter = this.model.type = 'Todos';
    if (environment.WHITELABEL === 2) {
      this.dailyMarketFilter = this.model.market = 'Bovespa';
    } else {
      this.dailyMarketFilter = this.model.market = 'Todos';
    }
    this.dailyStatusFilter = this.model.status = 'Todas';
    this.dailyDirectionFilter = this.model.direction = 'Todas';
  }

  openEditOrder(i, event) {
    event.stopPropagation();
    this.idDetails = -1;
    this.idEdit = i;
    document.getElementById('tr' + i).classList.add('hover-up');
    document.getElementById('trd' + i).classList.add('hover-down');
    this.toggleAnimate();
  }

  closeEditOrder(i, event?) {
    if (event) { event.stopPropagation(); }
    this.idEdit = -1;
    document.getElementById('tr' + i).classList.remove('hover-up');
    document.getElementById('trd' + i).classList.remove('hover-down');
    this.toggleAnimateClose();
  }

  clearFilter() {
    this.resetFilter();
    if (this.selectedTab === 0) {
      this.onSearchDaily();
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  openDetail(i) {
    this.idEdit = -1;
    this.idDetails = i;
    document.getElementById('tr' + i).classList.add('hover-up');
    document.getElementById('trd' + i).classList.add('hover-down');
    this.toggleAnimate();
  }

  closeDetail(i) {
    this.idDetails = -1;
    document.getElementById('tr' + i).classList.remove('hover-up');
    document.getElementById('trd' + i).classList.remove('hover-down');
    this.toggleAnimateClose();
  }

  toggleAnimate() {
    this.stateDetail = !this.stateDetail;
  }

  get stateDetails() {
    return this.stateDetail ? 'show' : 'hide';
  }

  toggleAnimateClose() {
    this.stateDetailClose = !this.stateDetailClose;
  }

  get stateDetailsClose() {
    return this.stateDetailClose ? 'showClose' : 'hideClose';
  }

  changeScreen(value) {
    this.orderList = [];
    this.resetFilter();
    if (this.selectedTab !== value) {
      this.selectedTab = value;
      if (this.selectedTab === 0) {
        this.onSearchDaily();
      } else {
        this.wasHistoryFetched = false;
      }
    }
  }

  changeDateIni(value) {
    this.dataIni = new Date(value);
  }

  changeDateFim(value) {
    this.dataFim = new Date(value);
  }

  sortBy(value, alternative = null) {
    if (this.currentFilter == value) {
      switch (this.filterDirection) {
        case 0:
          this.filterDirection = 1;
          if (value == 'stateName') {
            value = 'state';
          }
          this.orderList = this.doSorting(this.orderList, value, 0, alternative);
          break;
        case 1:
          this.filterDirection = 2;
          if (value == 'stateName') {
            value = 'state';
          }
          this.orderList = this.doSorting(this.orderList, value, 1, alternative);
          break;
        case 2:
          this.filterDirection = 0;
          this.orderList = this.sortWebfeederDate(this.orderList);
          break;
      }
    } else {
      this.currentFilter = value;
      this.filterDirection = 1;
      if (value == 'stateName') {
        value = 'state';
      }
      this.orderList = this.doSorting(this.orderList, value, 0, alternative);
    }
  }

  doSorting(list, value, direction, alternative = null) {
    if (direction == 1) {
      if (alternative == 'date') {
        return list.sort(function (obj1, obj2) {
          let datearray = obj1.transactTime.substring(0, 10).split('/');
          let newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
          const dateobj1 = new Date(newdate + obj1.transactTime.substring(10, 19));
          datearray = obj2.transactTime.substring(0, 10).split('/');
          newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
          const dateobj2 = new Date(newdate + obj2.transactTime.substring(10, 19));
          return dateobj2.getTime() - dateobj1.getTime();
        });
      }

      return (list.sort(function (a, b) {
        if (isNaN(parseFloat(a[value])) || isNaN(parseFloat(b[value]))) {
          if (a[value] > b[value]) { return -1; }
          if (a[value] < b[value]) { return 1; }
        }
        if (parseFloat(a[value].replace('.', '')) > parseFloat(b[value].replace('.', ''))) { return -1; }
        if (parseFloat(a[value].replace('.', '')) < parseFloat(b[value].replace('.', ''))) { return 1; }
      }));
    } else {

      if (alternative == 'date') {
        return list.sort(function (obj1, obj2) {
          let datearray = obj1.transactTime.substring(0, 10).split('/');
          let newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
          const dateobj1 = new Date(newdate + obj1.transactTime.substring(10, 19));
          datearray = obj2.transactTime.substring(0, 10).split('/');
          newdate = datearray[1] + '/' + datearray[0] + '/' + datearray[2];
          const dateobj2 = new Date(newdate + obj2.transactTime.substring(10, 19));
          return dateobj1.getTime() - dateobj2.getTime();
        });
      }

      return (list.sort(function (a, b) {
        if (isNaN(parseFloat(a[value])) || isNaN(parseFloat(b[value]))) {
          if (a[value] < b[value]) { return -1; }
          if (a[value] > b[value]) { return 1; }
        }
        if (parseFloat(a[value].replace('.', '')) < parseFloat(b[value].replace('.', ''))) { return -1; }
        if (parseFloat(a[value].replace('.', '')) > parseFloat(b[value].replace('.', ''))) { return 1; }
      }));
    }
  }

  selectAsset(value) {
    this.model.symbol = value.symbol;
  }

  checkForBlank(value) {
    this.model.symbol = '';
  }

  cancelOrder(data, event?) {
    event.stopPropagation();
    const modalOrders = this.dialog.open(NormalModalComponent, {
      data: { title: '', body: Constants.ORDER_HISTORY_MSG002, isHistoryOrderWSO2: false },
      panelClass: 'mat-modal-normal',
    });
    if (modalOrders) {
      modalOrders.afterClosed().subscribe(result => {
        if (result) {
          const cancelOrder: CancelOrder = this._dailyOrderService.transformCancelOrder(data);
          this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.CANCEL_ORDER, cancelOrder, false, null);
          this._dailyOrderService.cancelOrderConfirmation$.pipe(take(1)).subscribe(sucess => {
            if (sucess && this.selectedTab == 1) {
              this.onSearchHistory();
            }
          });
        }
      });
    }
  }

  reSendOrder(element, event?) {
    event.stopPropagation();
    const modalOrders = this.dialog.open(NormalModalComponent, {
      data: { title: '', body: Constants.ORDER_HISTORY_MSG015, isHistoryOrderWSO2: false },
      panelClass: 'mat-modal-normal',
    });
    if (modalOrders) {
      modalOrders.afterClosed().subscribe(confirm => {
        if (confirm) {
          this._authServer.iQuote.getQuote(element.quote)
            .subscribe((res: Quote) => {
              const model = this._dailyOrderService.convertDailyOrderToSendOrder(element);
              model.orderid = null;
              model.origclordid = null;
              model.loteDefault = res.loteDefault;
              this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.SEND_ORDER, model);
              this._dailyOrderService.editOrderConfirmation$.pipe(take(1))
              .subscribe(sucess => {
                if (sucess && this.selectedTab === 1) {
                  this.onSearchHistory();
                }
              });
            });
        }
      });
    }
  }

}
